
export default function PaintHero() {
  return (
    <section className="relative bg-gradient-to-br from-[#1A1A1A] to-[#2d2d2d] text-white py-12 md:py-20 px-4 md:px-8 overflow-x-hidden">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col md:flex-row items-center gap-8 md:gap-12">
          <div className="w-full md:w-1/2">
            <h1 className="font-['Montserrat'] font-bold text-[2rem] md:text-4xl lg:text-5xl mb-6 leading-tight">
              Paint &amp; Coatings
            </h1>
            <p className="text-base md:text-lg text-gray-300 mb-6">
              Premium paint and protective coatings for interior and exterior applications. Superior coverage, durability, and finish quality.
            </p>
            <div className="flex flex-wrap gap-3 mb-6">
              <div className="flex items-center gap-2">
                <div className="w-3 h-3 rounded-full flex-shrink-0" style={{ backgroundColor: '#F2C612' }}></div>
                <span className="text-sm md:text-base">Everyday</span>
              </div>
              <div className="flex items-center gap-2">
                <div className="w-3 h-3 rounded-full flex-shrink-0" style={{ backgroundColor: '#2D7AC2' }}></div>
                <span className="text-sm md:text-base">Contractor Grade</span>
              </div>
              <div className="flex items-center gap-2">
                <div className="w-3 h-3 rounded-full bg-red-600 flex-shrink-0"></div>
                <span className="text-sm md:text-base">Elite Pro</span>
              </div>
            </div>
          </div>
          <div className="w-full md:w-1/2">
            <div className="rounded-lg overflow-hidden">
              <img
                src="https://static.readdy.ai/image/783dd8c3d2d1f38f9648f46144ac17f1/65ad714713375d898c35137567a89d53.png"
                alt="Paint & Coatings"
                className="w-full h-full object-contain"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
